import { render, staticRenderFns } from "./search-pro.vue?vue&type=template&id=67bd4f7b&scoped=true&"
import script from "./search-pro.vue?vue&type=script&lang=js&"
export * from "./search-pro.vue?vue&type=script&lang=js&"
import style0 from "./search-pro.vue?vue&type=style&index=0&id=67bd4f7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bd4f7b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TinyButton: require('/web/components/TinyButton.vue').default,TheSearchByProps: require('/web/components/TheSearchByProps.vue').default})
